import { Box, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { TransferMoneyForm } from "src/widgets/transfer-money-form";
import { TransferMoneyFormValues } from "src/widgets/transfer-money-form/model/types";
import {
  sendTransferCloseRequest,
  sendTransferResult,
  sendTransferSuccess,
} from "src/shared/lib/iframe/transferIframeBridge";

export const IframeTransferMoneyPage = () => {
  const { client_id = "" } = useParams<{ client_id: string }>();

  const handleCancel = () => {
    sendTransferCloseRequest();
  };

  const handleSuccess = (values: TransferMoneyFormValues) => {
    sendTransferSuccess({
      clientId: client_id,
      transfersCount: values.accountsTo.length,
    });
  };

  const handleResult = (result: {
    status: "success" | "partial_success" | "error";
    message: string;
    transfersCount?: number;
    successCount?: number;
    failedCount?: number;
  }) => {
    sendTransferResult({
      clientId: client_id,
      ...result,
    });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 960,
          mx: "auto",
          p: 4,
          borderRadius: 3,
        }}
      >
        <TransferMoneyForm
          clientId={client_id}
          onCancel={handleCancel}
          onSuccess={handleSuccess}
          onResult={handleResult}
        />
      </Paper>
    </Box>
  );
};
